_ = require('lodash')

module.exports = ( PseudoTime, $q, $resource ) ->

  getShallowDataClone = (source) ->
    # Only clone data: avoid copying $resource-added $promise, $resolved,
    # and to avoid copying ng-repeat-added $$hashKey
    _.omit source, (value, key) ->
      key[0] == '$'

  shallowCloneData = (destination, source) ->
    shallowDataClone = getShallowDataClone(source)
    _.assign(destination, shallowDataClone)

  deepCloneData = (destination, source) ->
    deepDataClone = _.cloneDeep(getShallowDataClone(source))
    _.assign(destination, deepDataClone)

  ConcurrentResource = (url, paramDefaults, actions) ->

    Resource = $resource(url, paramDefaults, actions)

    members = {
      $$copyToSelf: () ->
        shallowCloneData(@, @$$resource)
        @

      $$copyToResource: () ->
        deepCloneData(@$$resource, @)
        @

      $mergeIn: (recentlyUpdatedResource) ->
        separateFromLastRequest = \
             (recentlyUpdatedResource.$$lastRequestFinishedAt < @$$lastRequestStartedAt ) \
          or (recentlyUpdatedResource.$$lastRequestStartedAt  > @$$lastRequestFinishedAt)
        if separateFromLastRequest
          deepCloneData(@, recentlyUpdatedResource)
        @

      $save: (params, success, failure) ->
        @$$copyToResource()
        @$$makeRequest () => @$$resource.$save(params, success, failure)

      $update: () ->
        @$$queuedData = deepCloneData({}, @)

        if @$resolved and @$$isQueued
          throw new Error('Invalid queue state')
        else if @$resolved and not @$$isQueued
          # Nothing in progress, so nothing is already queued
          @$$isQueued = true
          @$$flushQueue()
          @$promise
        else if not @$resolved and @$$isQueued
          # Already queued, which will pick up the next latest
          # data from @$$queuedData.
          @$$nextFlushPromise
        else if not @$resolved and not @$$isQueued
          # In progress, but nothing yet queued
          @$$isQueued = true
          @$$nextFlushPromise

      $$flushQueue: ()->
        if not @$$isQueued
          @$resolved = true
          return @

        shallowCloneData(@$$resource, @$$queuedData)
        @$$makeRequest () => @$$resource.$update()

      $$makeRequest: (requestFunc) ->
        @$$isQueued = false
        @$resolved = false

        # Resolves when this request is done
        @$$lastRequestStartedAt = PseudoTime()
        @$$lastRequestFinishedAt = Number.POSITIVE_INFINITY
        @$promise = requestFunc().then () =>
          @$$lastRequestFinishedAt = PseudoTime()
          if not @$$isQueued
            @$$copyToSelf()
          @
        , (rejection) =>
          @$$lastRequestFinishedAt = PseudoTime()
          @$$isQueued = false
          @$resolved = true
          $q.reject(rejection)

        # Resolves when the next flush is done
        # or immediately after it starts if there is nothing to do
        @$$nextFlushPromise = @$promise.then () =>
          @$$flushQueue()

        @$promise

      $updateAllowingValidationErrors: (params, success, failure) ->
        @$$copyToResource()
        @$promise = @$$resource.$updateAllowingValidationErrors(params, success, failure).then () =>
          @$$copyToSelf()

      $get: (params, success, failure) ->
        @$$copyToResource()
        @$promise = @$$resource.$get(params, success, failure).then () =>
          @$$copyToSelf()

      $delete: (params, success, failure) ->
        @$$copyToResource()
        @$promise = @$$resource.$delete(params, success, failure).then () =>
          @$$copyToSelf()

      $promise:   'MUST_BE_OVERRIDDEN_BY_INSTANCE'
      $$resource: 'MUST_BE_OVERRIDDEN_BY_INSTANCE'
    }

    # Member functions and the wrapped $resource are non enumerable in order for copying to never touch them.
    ConcurrentResource = Object.create Object.prototype, _.mapValues members, (func) ->
      value: func,
      enumerable: false
      writable: true  # Used to swap functions with spies in tests

    ConcurrentResourceConstructor = (data, startedAt) ->
      concurrentResource = Object.create(ConcurrentResource, {
        $$resource: {
          value: if data instanceof Resource then data else new Resource(deepCloneData({}, data)),
          enumerable: false
        },
        $promise: {
          value: $q.when(),
          enumerable: false,
          writable: true
        },
        $$nextFlushPromise: {
          value: $q.when(),
          enumerable: false,
          writable: true
        },
        $resolved: {
          value: true,
          enumerable: false,
          writable: true
        },
        $$isQueued: {
          value: false,
          enumerable: false,
          writable: true,
        },
        $$queuedData: {
          value: {},
          enumerable: false,
          writable: true,
        },
        $$lastRequestStartedAt: {
          value: startedAt or PseudoTime(),
          enumerable: false,
          writable: true,
        },
        $$lastRequestFinishedAt: {
          value: PseudoTime(),
          enumerable: false,
          writable: true,
        }
      })
      shallowCloneData(concurrentResource, concurrentResource.$$resource)

    makeConcurrentResource = (itemOrArray, startTime) ->
      if _.isArray(itemOrArray)
        _.map itemOrArray, (item) -> makeConcurrentResource(item, startTime)
      else if itemOrArray instanceof Resource
        new ConcurrentResourceConstructor(itemOrArray, startTime)
      else
        # A primitive that was not transformed by $resource
        itemOrArray

    ConcurrentResourceConstructor.get = () ->
      startTime = PseudoTime()
      result = Resource.get.apply(null, arguments)
      result.$promise = result.$promise.then (data) -> makeConcurrentResource(data, startTime)
      result

    ConcurrentResourceConstructor.query = () ->
      startTime = PseudoTime()
      result = Resource.query.apply(null, arguments)
      result.$promise = result.$promise.then (data) -> makeConcurrentResource(data, startTime)
      result

    ConcurrentResourceConstructor.queryAllowingErrors = () ->
      startTime = PseudoTime()
      result = Resource.queryAllowingErrors.apply(null, arguments)
      result.$promise = result.$promise.then (data) -> makeConcurrentResource(data, startTime)
      result

    ConcurrentResourceConstructor.save = () ->
      startTime = PseudoTime()
      result = Resource.save.apply(null, arguments)
      result.$promise = result.$promise.then (data) -> makeConcurrentResource(data, startTime)
      result

    ConcurrentResourceConstructor.update = () ->
      startTime = PseudoTime()
      result = Resource.update.apply(null, arguments)
      result.$promise = result.$promise.then (data) -> makeConcurrentResource(data, startTime)
      result

    ConcurrentResourceConstructor.delete = () ->
      startTime = PseudoTime()
      result = Resource.delete.apply(null, arguments)
      result.$promise = result.$promise.then (data) -> makeConcurrentResource(data, startTime)
      result

    return ConcurrentResourceConstructor

  return ConcurrentResource
